/* global NativeAppInterface */
export default class AndroidNativeAppInterface {
    emit(e) {
        NativeAppInterface.sendEvent(e);
    }
}
